import Vue from 'vue';
import VueRouter from 'vue-router';
import LayoutWrapper from '@/views/Layout/LayoutWrapper.vue';

Vue.use(VueRouter)

const routes = [
  {
    path: '/maintenance',
    name: 'maintenance',
    component: () => import ('../views/Maintenance.vue')
  },
  {
    path: '/:id',
    component: LayoutWrapper,
    redirect: {
      path: 'dashboard/:id/AUS'
    },
    children: [
      {
        path: `/dashboard/:id/:section`,
        name: 'dashboard',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "demo" */ '../views/HaloScenario.vue')
      },
      {
        path: '/adjustments/:id',
        name: 'adjustments',
        component: () => import(/* webpackChunkName: "demo" */ '../views/Adjustments.vue')
      },
      {
        path: '/compare/:id',
        name: 'compare',
        component: () => import(/* webpackChunkName: "demo" */ '../views/Compare.vue')
      },
      {
        path: '/compensatingFactors/:id',
        name: 'compensatingFactors',
        component: () => import(/* webpackChunkName: "demo" */ '../views/CompensatingFactors.vue')
      },
      {
        path: '/scenarioTool/:id/:section',
        name: 'scenarioTool',
        component: () => import(/* webpackChunkName: "demo" */ '../views/ScenarioTool.vue')
      },
      {
        path: '/',
        name: 'Not Found',
        component: () => import(/* webpackChunkName: "demo" */ '../views/NotFound.vue')
      },
    ]
  },
]

const router = new VueRouter({
  routes, // short for routes: routes
  linkActiveClass: 'active',
  scrollBehavior: (to, from, savedPosition) => {
    if (savedPosition) {
      return savedPosition;
    }
    if (to.hash) {
      return { selector: to.hash };
    }
    return { x: 0, y: 0 };
  }
})

export default router
